<!-- tinymce富文本编辑器组件 -->
<template>
  <div>
    <editor v-model="content" :value="value" :init="config" :disabled="disabled" />
    <ele-gallery :info-data="gallery_info" v-on:picReturn="picReturn"></ele-gallery>
  </div>
</template>

<script>
    import EleGallery from '@/components/EleGallery'
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/icons/default'
import 'tinymce/themes/silver'
import 'tinymce/plugins/code'
import 'tinymce/plugins/print'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/save'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/link'
// import 'tinymce/plugins/autolink'
// import 'tinymce/plugins/image'
// import 'tinymce/plugins/imagetools'
// import 'tinymce/plugins/media'
import 'tinymce/plugins/table'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/charmap'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/anchor'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/pagebreak'
// import 'tinymce/plugins/quickbars'
import 'tinymce/plugins/nonbreaking'
import 'tinymce/plugins/visualblocks'
import 'tinymce/plugins/visualchars'
import 'tinymce/plugins/wordcount'
// import 'tinymce/plugins/emoticons/js/emojis'

export default {
  name: 'TinymceEditor',
  components: { Editor,EleGallery },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: String,
    init: Object,
    disabled: Boolean,
  },
  data() {
    return {
        gallery_info: {
            status: false,
            num: 1,
        },
      content: '',
      mold_field: '',
      myEditor: null, //定义editor的全局变量
      config: Object.assign(
        {
          height: 300,
          branding: false,
          skin_url: '/tinymce/skins/ui/oxide',
          content_css: '/tinymce/skins/content/default/content.css',
          language_url: '/tinymce/langs/zh_CN.js',
          language: 'zh_CN',
          plugins:
            'code print preview fullscreen paste searchreplace save autosave link autolink table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
          toolbar:
            ' assignment | fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link emoticons charmap anchor pagebreak codesample | ltr rtl ',	//加入定义的按钮名到工具栏
          toolbar_drawer: 'sliding',
          images_upload_handler: (blobInfo, success, error) => {
            let file = blobInfo.blob()
            // 使用axios上传
            const formData = new FormData()
            formData.append('file', file, file.name)
            this.$http
              .post('/upload/uploadImage', formData)
              .then((res) => {
                if (res.data.code == 0) {
                  success(res.data.data)
                } else {
                  error(res.data.msg)
                }
              })
              .catch((e) => {
                console.error(e)
                error(e.message)
              })
          },
          //images_upload_handler: (blobInfo, success) => {
          //console.log(blobInfo)
          //success('data:image/jpeg;base64,' + blobInfo.base64());
          //},
          file_picker_types: 'media',
          file_picker_callback: () => {},
          setup: (editor) => {
              let _this = this
             
            _this.myEditor = editor
            
            //定义一个名为 assignment 的toolbar
            editor.ui.registry.addButton('assignment', {
              text: `<i class="el-icon-picture" style="font-size: 25px"></i>`,
              tooltip: '图片',
              onAction: () => {
                _this.gallery_info.status = true
              },
            })
          },
        },
        this.init
      ),
    }
  },
  methods: {
    //保存模块选中的值
    picReturn(e) {
        console.log(e);
      let _this = this
      _this.mold_field ='<img src="'+e.data[0]+'" alt="" width="100%" height="100%" />'
      _this.myEditor.insertContent(_this.mold_field)
    },
  },
  mounted() {
    tinymce.init({})
  },
  watch: {
    content() {
      this.$emit('change', this.content)
    },
    value() {
      this.content = this.value
    },
  },
}
</script>

<style>
body .tox-tinymce-aux {
  z-index: 19892000;
}
</style>
